// src/components/Servers.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API = "/api"; // same-origin to FastAPI

export default function Servers() {
  const [servers, setServers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  async function load() {
    setLoading(true);
    setErr("");
    try {
      const url = q
        ? `${API}/servers/?q=${encodeURIComponent(q)}`
        : `${API}/servers/`;
      const r = await fetch(url, { credentials: "include" });
      if (!r.ok) throw new Error(`Failed to load servers (HTTP ${r.status})`);
      const data = await r.json();
      setServers(data);
    } catch (e) {
      setErr(e.message || "Failed to load servers.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // initial load

  // re-run search with Enter or button
  function onKeyDown(e) {
    if (e.key === "Enter") load();
  }

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: "0 auto" }}>
      <h2 style={{ marginTop: 0 }}>Process Servers</h2>

      {/* Search */}
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Search name, company, email, phone, area…"
          style={{ flex: 1, padding: 8, borderRadius: 8, border: "1px solid #ddd" }}
        />
        <button
          onClick={load}
          style={{
            padding: "8px 14px",
            borderRadius: 8,
            background: "#111",
            color: "#fff",
            border: 0,
            cursor: "pointer",
          }}
        >
          Search
        </button>
      </div>

      {loading && <div>Loading…</div>}
      {err && <div style={{ color: "crimson", marginBottom: 10 }}>{err}</div>}

      {!loading && !err && (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              overflow: "hidden",
            }}
          >
            <thead style={{ background: "#fafafa" }}>
              <tr>
                <th style={th}>Name</th>
                <th style={th}>Server #</th>
                <th style={th}>Company</th>
                <th style={th}>Phone</th>
                <th style={th}>Email</th>
                <th style={th}>Status</th>
                <th style={th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {servers.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ padding: 18, textAlign: "center", color: "#666" }}>
                    No servers found.
                  </td>
                </tr>
              ) : (
                servers.map((s) => (
                  <tr key={s.id} style={{ borderTop: "1px solid #eee" }}>
                    <td style={td}>
                      <Link to={`/servers/${s.id}/edit`} title="Edit this server">
                        {s.name || `Server #${s.id}`}
                      </Link>
                    </td>
                    <td style={tdMono}>{s.server_number || "—"}</td>
                    <td style={td}>{s.company || "—"}</td>
                    <td style={td}>{s.phone || "—"}</td>
                    <td style={td}>{s.email || "—"}</td>
                    <td style={td}>{s.status || "—"}</td>
                    <td style={td}>
                      <Link to={`/servers/${s.id}/edit`}>Edit</Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const th = {
  textAlign: "left",
  padding: "10px 12px",
  fontSize: 13,
  color: "#444",
  borderBottom: "1px solid #e5e7eb",
  whiteSpace: "nowrap",
};

const td = {
  padding: "10px 12px",
  fontSize: 14,
  color: "#111",
  verticalAlign: "top",
};

const tdMono = {
  ...td,
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
};
